import React from 'react';
import { cl, globs,getRandomString } from '../../components/utils/utils';
import { sensorIds,wsTrans,initSensorIds } from '../utils/utils';
import C18Button00 from './C18Button00'


/**
 * Third Party API driver configuration page.
 *
 * Communicates with the backend through this.threePApi(driver, operation, params).
 * The backend stub is not yet implemented; all calls throw until wired up.
 */
class C18_3pApi extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      phase: 'loading',

      errorMessage: '',
      oauthError: false,

      drivers: [],
      selectedDriver: null,

      sensors: [],
      metrics: [],

      selectedSensor: null,
      selMetric: null,
      selSiteId: null,
      selZoneId: null,
      selSensorId: null,

      expandedChannels: {},
      howOftenStr: '00:00',
    };

    this.oauthState = null;
    this.subscribe_toClientEvent = null;

//     this.threePApi = this.threePApi.bind(this);
  }

  /**
   * Backend API stub. Replace with real implementation when available.
   *
   * @param {string|null} driver
   * @param {string} operation
   * @param {object|null} params
   * @returns {Promise<*>}
   */
  async threePApi(driver, operation, params) {
    void driver;
    void operation;
    void params;
//     cl(driver,operation,params)
    let res=await wsTrans("usa", {cmd: "cRest", uri: `/s/3pApi`,
      method:"retrieve", sessionId: globs.userData.session.sessionId,
      body: {driver:driver,operation:operation,params:params}})
//     cl(res)
    return res.data
//     throw new Error('3pApi() not implemented');
  }

  componentDidMount = () => {
    this.subscribe_toClientEvent =
      globs.events.subscribe('toClient', this.toClient);
//     this.loadDrivers();
    this.loadInfo()
  };

  componentWillUnmount = () => {
    if (this.subscribe_toClientEvent) {
      this.subscribe_toClientEvent.remove();
    }
  };

  // ---------------------------------------------------------------------------
  // Data loading
  // ---------------------------------------------------------------------------

  loadDrivers = async () => {
    this.setState({ phase: 'loading', errorMessage: '' });
    try {
      const drivers = await this.threePApi(null, 'listDrivers', null);
      this.setState({
        phase: 'selectDriver',
        drivers: Array.isArray(drivers) ? drivers : [],
      });
    } catch (err) {
      cl({ C18_3pApi: 'loadDrivers failed', error: err.message });
      this.setState({
        phase: 'error',
        errorMessage: err.message,
      });
    }
  };

  loadInfo=async()=>{
    await this.loadDrivers()
    let sn0=await this.threePApi(null, 'loadL4SensorNames', null);
    let sn1={}
    Object.keys(sn0).forEach(zk=>{// by zones
      sn1[zk]={}
      sn0[zk]=Object.keys(sn0[zk]).filter(snk=>snk.substring(0,4)=="e0gn")
        .forEach(snk=>{
          sn1[zk][snk]=sn0[zk][snk]
        })
//         .map(snk=>sn0[zk][snk])
    })
//     cl(sn1)
    this.setState({sensorNames:sn1})
  }

  configureDriver=async(driverId)=>{
    await this.threePApi(driverId,"configureDriver",null)
  }

  connectDriver=async(driverId)=>{
    await this.threePApi(driverId,"connectDriver",null)
  }

  writeSensor=async()=>{
    cl(this.state)
    const {
      selectedDriver,
      selMetric,
      selectedSensor,
      selZoneId,
      selSiteId,
      selSensorId,
    } = this.state;
    let zone=globs.zonesInfo.info.find(z=>z.zoneId==selZoneId)
//     cl(selectedSensor)
    let body={
      sensorId:selectedSensor.sensorId||getRandomString(16),
      siteId:selSiteId,//selectedSensor.siteId,
      zoneId:selZoneId,
      zInd:zone.siteZoneIndex,//selectedSensor.zInd,
      howOften:selectedSensor.howOften||60,
      nextRead:0,
      driver:selectedDriver,
      ch:selMetric.ch,
      met:selMetric.met,
      l4Sensor:selSensorId,
//       metric: selMetric,
//       siteId: selSiteId,
//       zoneId: selZoneId,
//       sensorId: selSensorId,
    }
//     cl(body)
    await this.threePApi(selectedDriver, 'writeSensor', body);

  }

  loadSensors=async(driverId)=>{
    let zoneLU={}
    let siteLU={}
    globs.zonesInfo.info.forEach(z=>zoneLU[z.zoneId]=z)
    globs.sitesInfo.info.forEach(s=>siteLU[s.siteId]=s)
    let sensors=await this.threePApi(driverId,"loadSensors",null)
    sensors.forEach(s=>{
//       cl(zoneLU[s.zoneId].siteZoneIndex)
//       let metric={ch:sensor.ch,met:sensor.met}
      s.zone=zoneLU[s.zoneId].zoneName
      s.zInd=zoneLU[s.zoneId].siteZoneIndex
      s.siteId=zoneLU[s.zoneId].siteId
      s.site=siteLU[s.siteId].name
      s.metric={ch:s.ch,met:s.met}
      s.link4Sensor=s.l4Sensor//this.state.sensorNames[s.zoneId][s.l4Sensor]
    })
    return sensors
  }

  testDriver = async (driverId) => {
    const driver = driverId || this.state.selectedDriver;
    if (!driver) {
      return;
    }

    this.setState({ phase: 'loading', errorMessage: '', oauthError: false });

    try {
      const response = await this.threePApi(driver, 'testDriver', null);
//       cl(response)
      if (response && response.success === true) {
        await this.loadSensorData(driver);
        this.setState({
          phase: 'configured',
          oauthError: false,
          errorMessage: '',
        });
      } else {
        this.setState({
          phase: 'unauthorized',
          sensors: [],
          metrics: [],
          selectedSensor: null,
          selMetric: null,
          selSiteId: null,
          selZoneId: null,
          selSensorId: null,
        });
      }
    } catch (err) {
      cl({ C18_3pApi: 'testDriver failed', error: err.message });
      this.setState({
        phase: 'error',
        errorMessage: err.message,
      });
    }
  };

  loadSensorData = async (driver) => {
    const metrics = await this.threePApi(driver, 'listSignals', null);
//     const metrics = await this.threePApi(driver, 'listMetrics', null);
//     cl(sensors)
    this.setState({
//       sensors: Array.isArray(sensors) ? sensors : [],
      metrics: Array.isArray(metrics) ? metrics : [],
    });
  };

  refreshSensors = async () => {
    const { selectedDriver } = this.state;
    if (!selectedDriver) {
      return;
    }
    try {
      const sensors = await this.loadSensors(selectedDriver)
//       const sensors = await this.threePApi(selectedDriver, 'loadSensors', null);
      this.setState({
        sensors: Array.isArray(sensors) ? sensors : [],
      });
    } catch (err) {
      cl({ C18_3pApi: 'refreshSensors failed', error: err.message });
      this.setState({
        phase: 'error',
        errorMessage: err.message,
      });
    }
  };

  // ---------------------------------------------------------------------------
  // Event handlers
  // ---------------------------------------------------------------------------

  onDriverChange = async (event) => {
    const driverId = event.target.value || null;
    if (!driverId) {
      this.setState({
        selectedDriver: null,
        phase: 'selectDriver',
        sensors: [],
        metrics: [],
        selectedSensor: null,
        selMetric: null,
        selSiteId: null,
        selZoneId: null,
        selSensorId: null,
        oauthError: false,
        errorMessage: '',
      });
      return;
    }
    await this.configureDriver(driverId)
    let sensors=await this.loadSensors(driverId)
//     cl(sensors)
//     cl("configured")
    this.setState({
      selectedDriver: driverId,
      sensors:sensors,
    }, async () => {
//       cl("testDriver")
      await this.connectDriver(driverId)
      await this.testDriver(driverId);
    });
  };

  onAuthorize = async () => {
    cl("onAuthorize")
    const { selectedDriver } = this.state;
    const accountId = globs.userData && globs.userData.session
      ? globs.userData.session.accountId
      : null;

    if (!selectedDriver) {
      this.setState({
        phase: 'error',
        errorMessage: 'Select a driver before authorizing',
      });
      return;
    }

    if (!accountId) {
      this.setState({
        phase: 'error',
        errorMessage: 'Account information is not available',
      });
      return;
    }

    try {
      const info = await this.threePApi(selectedDriver, 'getProviderInfo',
        {accountId:accountId});
      cl(info)
      return // Vivent is not using full OAuth2 - handled on server
      this.oauthState = `${accountId}*${selectedDriver}`;
      const oauthUrl = this.buildOAuthUrl(info);
      this.setState({ phase: 'authorizing' });
      window.location.href = oauthUrl;
    } catch (err) {
      cl({ C18_3pApi: 'onAuthorize failed', error: err.message });
      this.setState({
        phase: 'error',
        errorMessage: err.message,
      });
    }
  };

  toClient = (msg) => {
    cl(msg)
    if (!msg || msg.type !== 'oauth2') {
      return;
    }

    const expectedState = this.oauthState || this.buildOAuthState();
    cl(expectedState)
    if (!expectedState || msg.state !== expectedState) {
      return;
    }

    if (msg.result !== 'ok') {
      this.setState({
        phase: 'unauthorized',
        oauthError: true,
        errorMessage: 'OAuth2 Authentication Failed',
      });
      return;
    }

    this.handleOAuthSuccess();
  };

  handleOAuthSuccess = async () => {
    const { selectedDriver } = this.state;
    this.setState({ phase: 'loading', oauthError: false, errorMessage: '' });

    try {
      const response = await this.threePApi(selectedDriver, 'testDriver', null);
      if (response && response.result === true) {
        await this.loadSensorData(selectedDriver);
        this.setState({
          phase: 'configured',
          oauthError: false,
          errorMessage: '',
        });
      } else {
        this.setState({
          phase: 'unauthorized',
          oauthError: true,
          errorMessage: 'OAuth2 Authentication Failed2',
        });
      }
    } catch (err) {
      cl({ C18_3pApi: 'handleOAuthSuccess failed', error: err.message });
      this.setState({
        phase: 'error',
        errorMessage: err.message,
      });
    }
  };

  onAddSensor = () => {
    this.setState({
      phase: 'editing',
      selectedSensor: { howOften: 0 },
      selMetric: null,
      selSiteId: null,
      selZoneId: null,
      selSensorId: null,
      howOftenStr: '00:00',
    });
  };

  onEditSensor = (sensor) => {
//     cl(sensor)
    this.setState({
      phase: 'editing',
      selectedSensor: sensor,
      selMetric: sensor.metric || null,
      selSiteId: sensor.siteId || null,
      selZoneId: sensor.zoneId || null,
      selSensorId: sensor.link4Sensor || null,
      howOftenStr: this.secondsToMMSS(sensor.howOften || 0),
    });
  };

  onDeleteSensor = async (sensorId, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const { selectedDriver, selectedSensor, sensors } = this.state;
    if (!selectedDriver) {
      return;
    }

    try {
      let sensor=sensors.find(s=>s.sensorId==sensorId)
      await this.threePApi(selectedDriver, 'deleteSensor', { sensorId });
      await this.refreshSensors();
      if (selectedSensor && selectedSensor.sensorId === sensorId) {
        this.setState({
          phase: 'configured',
          selectedSensor: null,
          selMetric: null,
          selSiteId: null,
          selZoneId: null,
          selSensorId: null,
          howOftenStr: '00:00',
        });
      }
    } catch (err) {
      cl({ C18_3pApi: 'onDeleteSensor failed', error: err.message });
      this.setState({
        phase: 'error',
        errorMessage: err.message,
      });
    }
  };

  onSelectMetric = (metric) => {
    this.setState({ selMetric: metric });
  };

  onSelectSite = (siteId) => {
    this.setState({
      selSiteId: siteId,
      selZoneId: null,
    });
  };

  onSelectZone = (zoneId) => {
    const zones = globs.zonesInfo && Array.isArray(globs.zonesInfo.info)
      ? globs.zonesInfo.info
      : [];
    const zone = zones.find((z) => z.zoneId === zoneId);
    this.setState({
      selZoneId: zoneId,
      selSiteId: zone ? zone.siteId : null,
      selSensorId: null,
    });
  };

  onSelectLink4Sensor = (sensorKey) => {
    this.setState({ selSensorId: sensorKey });
  };

  onSaveSensor = async () => {
    const {
      selectedDriver,
      selMetric,
      selSiteId,
      selZoneId,
      selSensorId,
    } = this.state;

    if (!this.canSave()) {
      return;
    }

    this.setState({ phase: 'saving', errorMessage: '' });

    try {
      await this.writeSensor()
//       await this.threePApi(selectedDriver, 'writeSensor', {
//         metric: selMetric,
//         siteId: selSiteId,
//         zoneId: selZoneId,
//         sensorId: selSensorId,
//       });
      await this.refreshSensors();
      this.setState({
        phase: 'configured',
        selectedSensor: null,
        selMetric: null,
        selSiteId: null,
        selZoneId: null,
        selSensorId: null,
        howOftenStr: '00:00',
      });
    } catch (err) {
      cl({ C18_3pApi: 'onSaveSensor failed', error: err.message });
      this.setState({
        phase: 'editing',
        errorMessage: err.message,
      });
    }
  };

  // ---------------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------------

  secondsToMMSS = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };

  parseHowOften = (str) => {
    const [m = 0, s = 0] = str.split(':').map(Number);
    return (m || 0) * 60 + (s || 0);
  };

  handleDurationChange = (value) => {
    if (!/^\d{0,2}:\d{0,2}$/.test(value)) {
      return;
    }

    const [mStr = '', sStr = ''] = value.split(':');
    const m = mStr === '' ? 0 : Number(mStr);
    const s = sStr === '' ? 0 : Number(sStr);

    if (s > 59) {
      return;
    }

    const seconds = this.parseHowOften(value);
    const { selectedSensor } = this.state;
    this.setState({
      howOftenStr: value,
      selectedSensor: {
        ...(selectedSensor || {}),
        howOften: seconds,
      },
    });
  };

  handleDurationBlur = () => {
    const seconds = this.parseHowOften(this.state.howOftenStr);
    const normalized = this.secondsToMMSS(seconds);
    const { selectedSensor } = this.state;
    this.setState({
      howOftenStr: normalized,
      selectedSensor: {
        ...(selectedSensor || {}),
        howOften: seconds,
      },
    });
  };

  getGenericSensorEntries = () => {
    return Array.from({ length: 128 }, (_, i) => ({
      key: `e0gn${i}`,
      name: `Generic Sensor ${i + 1}`,
    }));
  };

  buildOAuthState = () => {
    const accountId = globs.userData && globs.userData.session
      ? globs.userData.session.accountId
      : null;
    const { selectedDriver } = this.state;
    if (!accountId || !selectedDriver) {
      return '';
    }
    return `${accountId}*${selectedDriver}`;
  };

  buildOAuthUrl = (info) => {
    if (!info || !info.providerUrl) {
      throw new Error('Provider information is incomplete');
    }

    const state = this.oauthState || this.buildOAuthState();
    const params = [
      ['response_type', 'code'],
      ['client_id', info.clientId],
      ['redirect_uri', info.redirect_uri],
      ['scope', info.scope],
      ['state', state],
      ['code_challenge', info.code_challenge],
      ['code_challenge_method', info.method || 'S256'],
    ];

    const query = params
      .map(([key, value]) => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(value == null ? '' : value)}`;
      })
      .join('&');

    const separator = info.providerUrl.indexOf('?') >= 0 ? '&' : '?';
    return `${info.providerUrl}${separator}${query}`;
  };

  isConfigurationEnabled = () => {
    const { phase } = this.state;
    return phase === 'configured' || phase === 'editing' || phase === 'saving';
  };

  shouldShowAuthorize = () => {
    const { phase, oauthError } = this.state;
    return phase === 'unauthorized' || (oauthError && phase !== 'configured');
  };

  canSave = () => {
    const { selMetric, selSiteId, selZoneId, selSensorId, phase } = this.state;
    if (phase === 'saving') {
      return false;
    }
    return Boolean(selMetric && selSiteId && selZoneId && selSensorId);
  };

  getSites = () => {
    if (!globs.sitesInfo || !Array.isArray(globs.sitesInfo.info)) {
      return [];
    }
    return [...globs.sitesInfo.info].sort((a, b) => {
      return (a.name || '').localeCompare(b.name || '');
    });
  };

  getAllZones = () => {
    if (!globs.zonesInfo || !Array.isArray(globs.zonesInfo.info)) {
      return [];
    }
    return [...globs.zonesInfo.info].sort((a, b) => {
      return (a.zoneName || '').localeCompare(b.zoneName || '');
    });
  };

  getZonesForSite = (siteId) => {
    if (!siteId || !globs.zonesInfo || !Array.isArray(globs.zonesInfo.info)) {
      return [];
    }
    return globs.zonesInfo.info
      .filter((zone) => zone.siteId === siteId)
      .sort((a, b) => {
        return (a.zoneName || '').localeCompare(b.zoneName || '');
      });
  };

  getLink4SensorEntries = (zoneId) => {
    if (!zoneId) {
      return this.getGenericSensorEntries();
    }
//     cl(zoneId)
    let sensorIds=this.state.sensorNames[zoneId]
//     cl(sensorIds)
    if (!sensorIds || typeof sensorIds !== 'object') {
      return [];
    }
    return Object.keys(sensorIds).map((key) => {
      const entry = sensorIds[key] || {};
      return {
        key,
        name: entry
      };
    });
  };

  getSelectedRowStyle = (isSelected) => {
    if (!isSelected) {
      return { cursor: 'pointer', padding: '4px 8px' };
    }
    return {
      cursor: 'pointer',
      padding: '4px 8px',
      background: '#C0E0FF',
    };
  };

  // ---------------------------------------------------------------------------
  // Rendering
  // ---------------------------------------------------------------------------

  render() {
    const { phase } = this.state;

    if (phase === 'loading') {
      return this.renderLoading();
    }

    return (
      <div style={{ padding: 16 }}>
        {this.renderError()}
        {this.renderDriverSelect()}
        {this.renderAuthorizeButton()}
        {this.renderConfiguration()}
      </div>
    );
  }

  renderLoading = () => {
    return (
      <div style={{ padding: 16 }}>
        Loading...
      </div>
    );
  };

  renderError = () => {
    const { errorMessage } = this.state;
    if (!errorMessage) {
      return null;
    }
    return (
      <div style={{ color: '#CC0000', marginBottom: 12 }}>
        {errorMessage}
      </div>
    );
  };

  renderDriverSelect = () => {
    const { drivers, selectedDriver } = this.state;

    return (
      <div style={{ marginBottom: 16 }}>
        <label htmlFor="c18-3papi-driver-select">
          Driver
        </label>
        <div>
          <select
            id="c18-3papi-driver-select"
            value={selectedDriver || ''}
            onChange={this.onDriverChange}
            style={{ minWidth: 240, marginTop: 4 }}
          >
            <option value="">Select Driver</option>
            {drivers.map((driver) => {
              return (
                <option key={driver.id} value={driver.id}>
                  {driver.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    );
  };

  renderAuthorizeButton = () => {
    if (!this.shouldShowAuthorize()) {
      return null;
    }

    return (
      <div style={{ marginBottom: 16 }}>
        <C18Button00 type="button" className="filled"
          onClick={this.onAuthorize}>
          Authorize
        </C18Button00>
      </div>
    );
  };

  renderConfiguration = () => {
    if (!this.isConfigurationEnabled()) {
      return null;
    }

    return (
      <div>
        {this.renderSensorTable()}
        {this.renderSensorEditor()}
      </div>
    );
  };

  renderSensorTable = () => {
    const { sensors } = this.state;
    const disabled = !this.isConfigurationEnabled();

    return (
      <div style={{ marginBottom: 16, maxHeight: 200, overflowY: 'auto' }}>
      <h3>Current Configured Sensors</h3>
        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', padding: '4px 8px', width: 40 }} />
              <th style={{ textAlign: 'left', padding: '4px 8px' }}>Sensor Metric</th>
              <th style={{ textAlign: 'left', padding: '4px 8px' }}>Site</th>
              <th style={{ textAlign: 'left', padding: '4px 8px' }}>Zone</th>
              <th style={{ textAlign: 'left', padding: '4px 8px' }}>Link4 Sensor</th>
            </tr>
          </thead>
          <tbody>
            <tr
              style={this.getSelectedRowStyle(false)}
              onClick={disabled ? null : this.onAddSensor}
            >
              <td style={{ padding: '4px 8px', color: 'blue', cursor: disabled ? 'default' : 'pointer', fontSize:24}}
                title="Add a Sensor"
              >
                +
              </td>
              <td colSpan={4} style={{ padding: '4px 8px', color: '#666' }}>
              </td>
            </tr>
            {sensors.map((sensor) => {
              return this.renderSensorRow(sensor, disabled);
            })}
          </tbody>
        </table>
      </div>
    );
  };

  renderSensorRow = (sensor, disabled) => {
//     cl(this.state)
    const { selectedSensor, sensorNames } = this.state;
    const isSelected = selectedSensor && selectedSensor.sensorId === sensor.sensorId;
//     cl(sensor)
    const onEdit = disabled ? null : () => { this.onEditSensor(sensor); };
    return (
      <tr
        key={sensor.sensorId}
        style={this.getSelectedRowStyle(isSelected)}
      >
        <td style={{ padding: '4px 8px' }}>
          <button
            type="button"
            title="Delete this Sensor"
            disabled={disabled}
            onClick={(event) => { this.onDeleteSensor(sensor.sensorId, event); }}
            style={{
              color: 'red',
              cursor: disabled ? 'default' : 'pointer',
              background: 'none',
              border: 'none',
              padding: 0,
              font: 'inherit',
            }}
          >
            X
          </button>
        </td>
        <td style={{ padding: '4px 8px' }} onClick={onEdit}>{`${sensor.ch}:${sensor.met}`}</td>
        <td style={{ padding: '4px 8px' }} onClick={onEdit}>{sensor.site}</td>
        <td style={{ padding: '4px 8px' }} onClick={onEdit}>{sensor.zone}</td>
        <td style={{ padding: '4px 8px' }} onClick={onEdit}>
        {sensorNames[sensor.zoneId][sensor.link4Sensor]}</td>
      </tr>
    );
  };

  renderSensorEditor = () => {
    const { phase, selectedSensor } = this.state;
    if (!selectedSensor) {
      return null;
    }
    if (phase !== 'editing' && phase !== 'saving') {
      return null;
    }

    return (
      <div>
        <h3>Edit Sensor Configuration</h3>
        {this.renderSelectionTables()}
        {this.renderSaveButton()}
      </div>
    );
  };

  renderSelectionTables = () => {
//     cl("renderSelectionTables")
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'nowrap',
          overflowX: 'auto',
          marginBottom: 12,
        }}
      >
        {this.renderMetricsTable()}
        {this.renderSitesTable()}
        {this.renderZonesTable()}
        {this.renderMapToTable()}
      </div>
    );
  };

  renderMetricsTable = () => {
    const { metrics, selMetric, expandedChannels } = this.state;
//     cl(metrics);

    const metricsByChannel = new Map();
    for (const metric of metrics) {
      if (!metricsByChannel.has(metric.ch)) {
        metricsByChannel.set(metric.ch, []);
      }
      metricsByChannel.get(metric.ch).push(metric);
    }

    const isMetricSelected = (metric) => {
//       cl(selMetric,metric)
      if (!selMetric) {
        return false;
      }
      return selMetric.ch === metric.ch && selMetric.met === metric.met;
    };

    const isChannelSelected = (channelId) => {
      if (!selMetric) {
        return false;
      }
      return selMetric.ch === channelId/* && selMetric.met === metric.met*/;
    };

    const toggleChannel = (channelId) => {
      this.setState((prev) => ({
        expandedChannels: {
          ...prev.expandedChannels,
          [channelId]: !prev.expandedChannels[channelId],
        },
      }));
    };

    return (
      <div style={this.getSelectionTableStyle()}>
        <div style={{ fontWeight: 'bold', marginBottom: 4 }}>Metrics</div>
        <div style={{ overflowY: 'auto', height: 200 }}>
          {Array.from(metricsByChannel.entries()).map(([channelId, channelMetrics]) => {
            const isExpanded = Boolean(expandedChannels[channelId]);
            const isChanSelected = isChannelSelected(channelId);
            return (
              <div key={channelId}>
                <div
                  style={{ cursor: 'pointer', padding: '4px 8px',
                    background:(isChanSelected&&!isExpanded)?'#E0F0FF':null
                  }}
                  onClick={() => { toggleChannel(channelId); }}
                >
                  {isExpanded ? '- ' : '+ '}{channelId}
                </div>
                {isExpanded && channelMetrics.map((metric) => {
                  const isSelected = isMetricSelected(metric);
                  return (
                    <div
                      key={`${metric.ch}:${metric.met}`}
                      style={{
                        ...this.getSelectedRowStyle(isSelected),
                        paddingLeft: 24,
                      }}
                      onClick={() => { this.onSelectMetric(metric); }}
                    >
                      {metric.name}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  renderSitesTable = () => {
    const { selSiteId } = this.state;
    const sites = this.getSites();

    return (
      <div style={this.getSelectionTableStyle()}>
        <div style={{ fontWeight: 'bold', marginBottom: 4 }}>Sites</div>
        <div style={{ overflowY: 'auto', height: 200 }}>
          {sites.map((site) => {
            const isSelected = selSiteId === site.siteId;
            return (
              <div
                key={site.siteId}
                style={this.getSelectedRowStyle(isSelected)}
                onClick={() => { this.onSelectSite(site.siteId); }}
              >
                {site.name}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  renderZonesTable = () => {
    const { selSiteId, selZoneId } = this.state;
    const zones = selSiteId ? this.getZonesForSite(selSiteId) : this.getAllZones();

    return (
      <div style={this.getSelectionTableStyle()}>
        <div style={{ fontWeight: 'bold', marginBottom: 4 }}>Zones</div>
        <div style={{ overflowY: 'auto', height: 200 }}>
          {zones.map((zone) => {
            const isSelected = selZoneId === zone.zoneId;
            return (
              <div
                key={zone.zoneId}
                style={this.getSelectedRowStyle(isSelected)}
                onClick={() => { this.onSelectZone(zone.zoneId); }}
              >
                {zone.zoneName}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  renderMapToTable = () => {
//     cl(this.state)
    const { selSensorId } = this.state;
    const entries = this.getLink4SensorEntries(this.state.selZoneId);
//     cl(entries)

    return (
      <div style={this.getSelectionTableStyle()}>
        <div style={{ fontWeight: 'bold', marginBottom: 4 }}>Map To</div>
        <div style={{ overflowY: 'auto', height: 200 }}>
          {entries.map((entry) => {
//             cl(entry)
            const isSelected = selSensorId === entry.key;
            return (
              <div
                key={entry.key}
                style={this.getSelectedRowStyle(isSelected)}
                onClick={() => { this.onSelectLink4Sensor(entry.key); }}
              >
                {entry.name}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  renderSaveButton = () => {
    const { phase, howOftenStr } = this.state;
    const enabled = this.canSave();

    return (
      <div>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="c18-3papi-how-often">
            Read How Often
          </label>
          <div>
            <input
              id="c18-3papi-how-often"
              type="text"
              placeholder="00:00"
              inputMode="numeric"
              title="How Often (minutes:seconds)"
              value={howOftenStr}
              onChange={(e) => { this.handleDurationChange(e.target.value); }}
              onBlur={this.handleDurationBlur}
              style={{ marginTop: 4, display:"inline-block", width:80 }}
            />
            {' '}(MM:SS)
          </div>
        </div>
        <C18Button00 type="button" className="filled"
          onClick={this.onSaveSensor}
          disabled={!enabled}
        >
          {phase === 'saving' ? 'Saving...' : 'Save'}
        </C18Button00>
      </div>
    );
  };

  getSelectionTableStyle = () => {
    return {
      minWidth: 140,
      marginRight: 12,
      border: '1px solid #CCCCCC',
      padding: 8,
      height: 200,
      boxSizing: 'border-box',
    };
  };
}

export default C18_3pApi;
